import React, { Fragment } from 'react';

const IconCardRowNoodles = (props) => {
  return (
    <Fragment>
      {props.theme === 'citipower-theme' ? (
        // blue noodle
        <svg
          className="noodle-large"
          width="1440"
          height="411"
          viewBox="0 0 1440 411"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask0_1_7"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="-409"
            y="0"
            width="1968"
            height="411"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M1558.35 80.5641C1554.89 105.819 1531.6 123.482 1506.35 120.014C970.23 46.4018 681.006 132.293 440.356 227.926C407.917 240.818 376.106 254.025 344.486 267.152C139.139 352.407 -58.1663 434.322 -367.242 404.706C-392.618 402.274 -411.218 379.732 -408.786 354.356C-406.355 328.98 -383.812 310.38 -358.437 312.812C-73.4341 340.121 103.159 267.031 307.55 182.435C339.596 169.171 372.326 155.624 406.264 142.137C659.113 41.6564 964.45 -47.573 1518.91 28.557C1544.16 32.0246 1561.82 55.3091 1558.35 80.5641Z"
              fill="#1F3B8A"
            />
          </mask>
          <g mask="url(#mask0_1_7)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M1558.35 80.5641C1554.89 105.819 1531.6 123.482 1506.35 120.014C970.23 46.4018 681.006 132.293 440.356 227.926C407.917 240.818 376.106 254.025 344.486 267.152C139.139 352.407 -58.1663 434.322 -367.242 404.706C-392.618 402.274 -411.218 379.732 -408.786 354.356C-406.355 328.98 -383.812 310.38 -358.437 312.812C-73.4341 340.121 103.159 267.031 307.55 182.435C339.596 169.171 372.326 155.624 406.264 142.137C659.113 41.6564 964.45 -47.573 1518.91 28.557C1544.16 32.0246 1561.82 55.3091 1558.35 80.5641Z"
              fill="url(#paint0_linear_1_7)"
            />
            <rect
              x="286"
              y="-657"
              width="1754"
              height="1214"
              fill="url(#paint1_radial_1_7)"
              className="noodle-move"
              style={{
                transform: `translateX(${props.gradientPositionX}%) translateY(${props.gradientPositionY}%)`,
              }}
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_1_7"
              x1="1567.5"
              y1="14.5"
              x2="-442"
              y2="391"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="1" stopColor="#1F3B8A" />
            </linearGradient>
            <radialGradient
              id="paint1_radial_1_7"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(1163 -50) rotate(90) scale(607 877)"
            >
              <stop stopColor="#0079C1" />
              <stop offset="1" stopColor="#ACD0E8" stopOpacity="0" />
            </radialGradient>
          </defs>
        </svg>
      ) : (
        // red noodle
        <svg
          className="noodle-large"
          width="1440"
          height="411"
          viewBox="0 0 1440 411"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask_123"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="-409"
            y="0"
            width="1968"
            height="411"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M1558.35 80.5641C1554.89 105.819 1531.6 123.482 1506.35 120.014C970.23 46.4018 681.006 132.293 440.356 227.926C407.917 240.818 376.106 254.025 344.486 267.152C139.139 352.407 -58.1663 434.322 -367.242 404.706C-392.618 402.274 -411.218 379.732 -408.786 354.356C-406.355 328.98 -383.812 310.38 -358.437 312.812C-73.4341 340.121 103.159 267.031 307.55 182.435C339.596 169.171 372.326 155.624 406.264 142.137C659.113 41.6564 964.45 -47.573 1518.91 28.557C1544.16 32.0246 1561.82 55.3091 1558.35 80.5641Z"
              fill="#882B3C"
            />
          </mask>
          <g mask="url(#mask_123)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M1558.35 80.5641C1554.89 105.819 1531.6 123.482 1506.35 120.014C970.23 46.4018 681.006 132.293 440.356 227.926C407.917 240.818 376.106 254.025 344.486 267.152C139.139 352.407 -58.1663 434.322 -367.242 404.706C-392.618 402.274 -411.218 379.732 -408.786 354.356C-406.355 328.98 -383.812 310.38 -358.437 312.812C-73.4341 340.121 103.159 267.031 307.55 182.435C339.596 169.171 372.326 155.624 406.264 142.137C659.113 41.6564 964.45 -47.573 1518.91 28.557C1544.16 32.0246 1561.82 55.3091 1558.35 80.5641Z"
              fill="url(#paint0_linear_123)"
            />
            <rect
              x="286"
              y="-657"
              width="1754"
              height="1214"
              fill="url(#paint1_radial_123)"
              className="noodle-move"
              style={{
                transform: `translateX(${props.gradientPositionX}%) translateY(${props.gradientPositionY}%)`,
              }}
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_123"
              x1="1567.5"
              y1="14.5"
              x2="-442"
              y2="391"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="1" stopColor="#882B3C" />
            </linearGradient>
            <radialGradient
              id="paint1_radial_123"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(1163 -50) rotate(90) scale(607 877)"
            >
              <stop stopColor="#EB0700" />
              <stop offset="1" stopColor="#EB0700" stopOpacity="0" />
            </radialGradient>
          </defs>
        </svg>
      )}
    </Fragment>
  );
};

export default IconCardRowNoodles;
